<template>
  <div class="protocolA0009">
    <div class="main" style="padding: 0 6% 15px 6%;">
        <p class="title" style="text-align: center;margin-top: 10px;margin-bottom: 3px;background:rgba(255,255,255,0);">WiFi万能钥匙用户安全保险协议</p>
        <p class="text ti">本协议为WiFi万能钥匙用户（即同意并接受了《WiFi万能钥匙服务协议》的用户，以下简称“用户”）与南京尚网网络科技有限公司（以下简称“WiFi万能钥匙”或“本公司”）关于WiFi万能钥匙安全保险事宜所订立的协议。</p>
        <p class="text ti">——本公司在此依法做出特别声明如下：</p>
        <p class="text ti">本公司采取合理的方式提请用户注意的义务将通过如下方式实现：在本协议中本公司以明确的足以引起用户注意的加重字体、斜体、下划线、颜色标记等合理方式提醒用户注意相关条款（需要强调的是，还包括用户应特别注意任何未明确标记的含有“不承担”、“免责”“不得”等形式用语的条款），该等条款的确认将导致用户在特定情况下的被动、不便、损失，请用户在确认同意本协议之前再次阅读上述条款。双方确认上述条款非属于《合同法》第40条规定的“免除其责任、加重对方责任、排除对方主要权利的”的条款。</p>
        <p class="text ti">鉴于本公司已依法明确了上述条款、履行了格式条款制订方的义务，用户点击同意或下一步，将被视为且应当被视为用户已经完全注意并同意了本协议所有条款尤其是提醒用户注意的条款的合法性及有效性，用户不应当以本公司未对格式条款以合理方式提醒用户注意，或未根据用户要求尽到说明义务为理由而声称或要求法院或其它任何第三方确认相关条款非法或无效。</p>
        <p class="text ti">——本协议可由本公司随时更新，更新后的协议条款一旦公布即代替原来的协议条款，用户可在软件客户端查阅最新版协议条款。<span style="font-weight:bold;text-decoration: underline;">如用户不同意本协议中的任一规定及/或本公司对本协议作出的任何修改，可以选择不参加本保险计划；一旦用户发起索赔申请，即视为用户已经了解并完全同意本协议各项条款及本公司对本协议及保险计划随时作出的修改。</span></p>

        <p class="title_bold">一、协议总则</p>
        <p class="text ti">WiFi万能钥匙用户安全保险计划：是指本公司用户在使用WiFi万能钥匙连接网络的过程中，因在通过WiFi万能钥匙连接的热点网络环境下发生了本协议中列明的WiFi热点恶意行为，导致用户本人在银行账户内的资产，及用户在合法运营的第三方支付机构所设本人实名账户中的资产遭受直接损失，用户可按照本保险计划的有关规则申请索赔。</p>
        <p class="text ti">本公司已通过众安在线财产保险股份有限公司（以下简称“保险公司”）为WiFi万能钥匙的安全性进行投保。WiFi万能钥匙用户安全保险计划（以下简称“保险计划”） 旨在为用户营造一个安全、可信的网络环境，让用户更放心地使用本公司提供的服务。</p>
        
        <p class="title_bold">二、定义</p>
        <p class="text ti">在本协议中，除非另有明确约定，提及的词语应具有如下含义：</p>
        <p class="text ti">WiFi热点：本协议中所述WiFi热点特指通过WLAN无线协议将网络连接进行延伸的无线接入点,为方便用户理解和辨识，本协议中将WiFi热点特分为有钥匙热点和无钥匙热点；</p>
        <p class="text ti">有钥匙热点：用户通过点击WiFi万能钥匙客户端中的“一键查询”功能，成功查询附近热点后，在热点上标识有蓝色钥匙的热点；</p>
        <p class="text ti">无钥匙热点：用户通过点击WiFi万能钥匙客户端中的“一键查询”功能，成功查询附近热点后，在热点上未标识蓝色钥匙的热点；钓鱼热点：本协议中所述钓鱼热点特指利用WiFi热点开放的特性，模拟正规合法的WiFi热点，以窃取用户私有信息、盗取用户财产等为目的而私自架设的热点。其形式上和正规合法的WiFi热点没有区别，一般公众很难区分；</p>
        <p class="text ti">钓鱼网站：指不法分子在互联网上建立的通过模仿合法、正规购物平台的网址或页面内容，利用发布虚假消息，搜集客户资料，骗取客户账户（登录ID）、密码、口令等信息进而达到非法窃取客户财物的目的非法网站；</p>
        <p class="text ti">木马病毒：指不法分子通过各种网络技术手段来篡改用户交易信息或者劫持用户交易过程等方式来达到盗取用户资金目的的恶意程序；</p>
        <p class="text ti">恶意软件："恶意软件"用作一个集合名词，来指代故意在计算机系统恶意软件上执行恶意任务的蠕虫、木马病毒或其他病毒；在恶意软件未被发现的这段时间，用户上网过程中的所有个人资料都有可能被盗走，比如银行账户信息，信用卡密码等；</p>
        <p class="text ti">DNS /DNS劫持：本协议中所述DNS是指网络定义的一种协议,为域名和IP地址相互映射，能够使用户更方便地访问互联网,DNS劫持是指恶意攻击者通过中间人攻击篡改域名和IP的对应关系,从而导致用户访问一些虚假的网站；</p>
        <p class="text ti">热点劫持：本协议中所述热点劫持是指恶意攻击者通过恶意攻击劫持原有WiFi热点，从而捕捉通过热点中的所有用户个人信息及其他信息；</p>
        <p class="text ti">账户资金：用户本人在银行账户内的资产，及用户在合法运营的第三方支付机构所设本人实名账户中的资产；</p>
        <p class="text ti">直接损失：因符合理赔范围的情形而被盗取的账户资金。</p>

        <p class="title_bold">三、索赔条件及理赔范围</p>

        <p class="text ti">用户应同时具备以下（一）至（五）款列明的各项条件，方可根据本公司用户安全理赔规则申请索赔:</p>
        <p class="title_bold">（一）索赔的前提条件</p>
        <p class="text ti">1.用户必须是WiFi万能钥匙的手机注册用户，且其安装并使用的WiFi万能钥匙手机客户端中必须已发布施行了本保险计划（即用户必须安装WiFi万能钥匙女生版安卓版1.0.0以上版本及此后发布的更新版本）。</p>
        <p class="text ti">2.用户在使用WiFi万能钥匙连接网络的过程中，因在通过WiFi万能钥匙连接的热点网络环境下发生了本协议中列明的WiFi热点恶意行为，导致用户账户资金被恶意第三方盗取。</p>
        <p class="text ti">3.因用户使用WiFi万能钥匙导致账户资金被盗，应首次发生于本用户安全保险计划生效日之后。</p>
        <p class="text ti">4.用户同意，在使用WiFi万能钥匙时向本公司提供其真实有效信息，且上述信息应与用户提交的索赔申请材料中的信息一致，即与本公司订立本协议的用户与实际使用WiFi万能钥匙遭受损失并前来申请索赔的用户必须为同一自然人用户。</p>
        <p class="text ti">5.用户使用WiFi万能钥匙连接的热点是有钥匙热点。</p>
        <p class="text ti">6.用户自使用WiFi万能钥匙连接特定无线网络开始至断开该无线网络的过程中，发生本协议第三条第（二）款中的情形而遭受了直接损失。</p>
        <p class="text ti">7.用户按照本条第（五）款索赔流程的规定向公安机关报案并向保险公司提交了符合索赔要求的材料。</p>
        <p class="text ti">8.用户因使用WiFi万能钥匙导致用户银行账户资金和有资质的第三方支付软件中的资金遭受损失的事件必须发生在中华人民共和国大陆地区（不包括香港、澳门和台湾地区）。</p>
        <p class="title_bold">（二）属于理赔范围的情形</p>
        <p class="text ti">1.用户欲前往特定合法网络购物网站、网络银行网站或第三方支付网站（以上简称“合法网站”）进行购物、转账等操作时，用户在支付交易过程中DNS被钓鱼热点进行了信息篡改，从而导致用户账户资金被盗的；</p>
        <p class="text ti">2.用户欲前往合法网站进行购物、转账等操作时，钓鱼热点已对该网站进行了DNS劫持，从而使用户连接上了一个钓鱼网站，导致了用户账户资金被盗的；</p>
        <p class="text ti">3.用户在合法网站正常操作购物、转账等操作的过程中，钓鱼热点非法获取了用户录入及传递的个人信息，导致用户信息泄露继而造成账户资金被盗；</p>
        <p class="text ti">4.用户欲下载特定应用软件，用户连接的热点被劫持后，用户实际下载了仿冒恶意软件，且一般用户无法判断该软件的真伪。用户在仿冒恶意软件中录入个人信息，或仿冒软件将劫持的用户短信等个人信息发送至恶意第三方，从而导致用户账户资金遭受损失。</p>
        <p class="title_bold">（三）不属于理赔范围的情形</p>
        <p class="title_bold">用户因以下情形产生的经济损失或其他损失，不属于理赔范围，无权向本公司或保险公司申请索赔：</p>
        <p class="title_bold ti">1.用户不具备本协议第三条第（一）款中列明的索赔前提条件；</p>
        <p class="title_bold ti">2.用户使用WiFi万能钥匙连接的热点是无钥匙热点；</p>
        <p class="title_bold ti">3.用户不能根据本保险计划规定提供证据及/或其他索赔材料的；</p>
        <p class="title_bold ti">4.用户未依据本协议第三条第（五）款中的规定进行报案和/或进行证据保全的；</p>
        <p class="title_bold ti">5.自使用WiFi万能钥匙遭受直接经济损失之日起15个自然日内，用户未依据本协议第三条第（五）款中的规定向保险公司提交索赔材料的；</p>
        <p class="title_bold ti">6.用户使用WiFi万能钥匙连接网络的行为与用户遭受的财产损失不具有直接因果关系；</p>
        <p class="title_bold ti">7.钓鱼热点、钓鱼网站及网络木马病毒、恶意软件的相关欺诈和/或劫持行为与用户所遭受的财产损失不具有直接因果关系；</p>
        <p class="title_bold ti">8.虚假诈骗广告信息植入在某个特定热点中，用户连接该热点后，轻信了该虚假广告信息，从而遭受了财产损失；</p>
        <p class="title_bold ti">9.虚假诈骗广告信息或恶意软件下载链接是植入在普通网站中的，用户使用WiFi万能钥匙连接网络后，在正常浏览网页的过程中因上述虚假广告或恶意软件遭受了财产损失；</p>
        <p class="title_bold ti">10.在用户使用WiFi万能钥匙连接网络并上网的过程中，因用户故意或重大过失导致下列情形的财产损失：</p>
        <p class="title_bold ti">（1）用户主动向他人账号划转资金或主动为他人发送的代付链接付款的；</p>
        <p class="title_bold ti">（2）用户通过网上交易购买机票或火车票时，向不具有在线销售资质的且收款人账号非为公司账号的网站划转资金或付款；</p>
        <p class="title_bold ti">（3）用户主动泄露网上银行账号、密码、支付短信的交易验证码或其他可能导致财产损失的信息，或主动允许他人远程协助的；</p>
        <p class="title_bold ti">（4）网上银行账号、密码已被他人知悉，或丢失了数字证书载体后，用户未立即变更账号、密码或通知银行冻结网上银行账户的；</p>
        <p class="title_bold ti">（5）其他因用户故意或重大过失导致的财产损失；</p>
        <p class="title_bold ti">11. 用户网购过程中，因商家违背诚信经营原则导致下列情形的财产损失：</p>
        <p class="title_bold ti">（1）与商家因交易纠纷造成的损失，包括但不限于电子商务商家账号被盗等引起的一切财产损失；</p>
        <p class="title_bold ti">（2）由于商家不诚信问题造成的损失，包括但不限于商品或服务的描述与实际不符，商品或服务的质量、价格、售后服务等引发消费纠纷而引起的一切财产损失；</p>
        <p class="title_bold ti">（3）虽经网页链接跳转，但用户系在正规网站进行正常交易行为时，由于商家违背诚信经营原则而遭受的财产损失。</p>
        <p class="title_bold ti">12.用户网购过程中，因其所购买标的物之特殊性导致的下列情形的财产损失：</p>
        <p class="title_bold ti">（1）用户在网络游戏私服中进行的交易或充值行为；</p>
        <p class="title_bold ti">（2）以虚拟物品为交易对象的，包括但不限于虚拟财产（如虚拟游戏装备、虚拟货币、虚拟道具等）、游戏人物、游戏辅助物品的，或用户在网络游戏中直接交换物品的；</p>
        <p class="title_bold ti">（3）用户购买药品、保健品的；</p>
        <p class="title_bold ti">（4）涉及盗版及仿制品、走私、非法销售物品的交易；</p>
        <p class="title_bold ti">（5）涉及网络赌博、博彩类交易（包括但不限于“赌球”、“21点”、“押大小”、“购买彩票”等）；</p>
        <p class="title_bold ti">（6）其他涉嫌购买国家法律禁止销售或者交易的物品的任何交易。</p>
        <p class="title_bold ti">13.网站经营者或任何第三方已赔偿或补偿了用户经济损失，或用户经WiFi万能钥匙协助已挽回经济损失，或用户已通过WiFi万能钥匙的其他理赔/保障计划获得赔偿的；</p>
        <p class="title_bold ti">14.财产损失超出本协议第三条第（四）款中索赔限额的部分；</p>
        <p class="title_bold ti">15.用户故意骗保，或在未发生理赔情形或未遭受任何财产损失的前提下谎称发生了理赔情形或伪造损失证据的，或用户因从事非法行为而遭受的任何损失；</p>
        <p class="title_bold ti">16.用户有损害本公司商誉、扰乱本公司正常经营秩序言行的；</p>
        <p class="title_bold ti">17.针对同一索赔事件，保险公司向用户进行理赔后，用户又追加索赔申请的；</p>
        <p class="title_bold ti">18.WiFi万能钥匙或保险公司工作人员依照本协议的约定联系用户时，自首次尝试联系用户起72小时内仍无法与用户取得联系的，或用户不履行本协议约定的配合义务的；</p>
        <p class="title_bold ti">19.用户遭受的直接经济损失以外的一切间接损失、预期利益、精神损害或其他损失；</p>
        <p class="title_bold ti">20.其他根据WiFi万能钥匙用户安全保险计划不属于理赔范围的情形。</p>
        <p class="title_bold">（四）索赔限额</p>
        <p class="text ti">
            <table width="100%" border=1 cellpadding="0" cellspacing="0">
                <tr>
                    <td>保险责任</td>
                    <td>每一用户单日/单次索赔限额</td>
                    <td>每一用户累计索赔限额</td>
                </tr>
                <tr>
                    <td>WiFi万能钥匙在提供服务的过程中造成了用户损失</td>
                    <td>人民币贰万元整</td>
                    <td>人民币壹拾万元整</td>
                </tr>
            </table>
        </p>
        <p class="text ti">单次事故赔偿限额：人民币壹佰万元整</p>
        <p class="text ti">（单次事故：指因同一或基本相同的风险原因导致的一系列索赔事件（即群体性事件），视为一起事故，前述风险原因的认定以本公司技术部门的判定结果作为标准）</p>
        <p class="title_bold">（五）索赔流程</p>
        <p class="text ti">1.证据保全：用户在使用WiFi万能钥匙连接网络的过程中，发现账户资金遭受损失的，应立即采取相关证据保全措施，不应自行刷机、清理手机垃圾、删除WiFi万能钥匙客户端、历史短信或历史访问网址记录，或自行删除交易过程中与交易对方的聊天记录及所下载的软件，以免导致相关证据无法保全；</p>
        <p class="text ti">2.报案：用户在使用WiFi万能钥匙连接网络的过程中，发现账户资金遭受损失的，应立即拨打保险公司电话进行报案，并应于10个自然日内前往具有管辖权的公安机关进行报案，并取得案件受理通知书等相关证明材料；</p>
        <p class="text ti">3.准备索赔资料：用户应自账户资金遭受经济损失之日起15个自然日内WiFi万能钥匙官网或者客户端索赔界面的提示准备索赔资料，并听从工作人员的操作指导，积极配合工作人员的工作，并配合提供相关损失证明文件，以便有效追查被盗情况并保全证据；</p>
        <p class="text ti">4.提交索赔资料：用户应根据保险公司工作人员的指示提交索赔资料，并确保其所提交的资料的真实性，否则，本公司及保险公司有权拒绝受理或赔付用户的索赔申请；用户知悉并了解，该等资料中的相关信息包括但不限于用户身份证号码、银行卡号、手机号码、详细住址等个人信息，用户在此同意并授权本公司及保险公司为实现本协议项下的索赔目的对用户的该等个人信息予以采集和使用；</p>
        <p class="text ti">用户应通过线下快递方式递交如下索赔资料：</p>
        <p class="text ti">身份证正反面彩色复印件（非中华人民共和国公民请提交有效护照彩色复印件）</p>
        <p class="text ti">向公安机关报案的相关证明（报案或立案证明）</p>
        <p class="text ti">非本人授权交易补偿申请表</p>
        <p class="text ti">索赔人被盗账户信息截屏</p>
        <p class="text ti">被盗账户对账单截屏（须标记盗刷交易明细信息：交易日期、交易商户、交易币种、交易金额、入账币种、入账金额）</p>
        <p class="text ti">被盗账户挂失证明（信息截屏，包含挂失日期等）</p>
        <p class="title_bold ti">索赔人出险期间手机设备在公安机关的备案数据</p>
        <p class="text ti">被盗账户近半年交易数据（如有）</p>
        <p class="text ti">涉及诉讼、仲裁的，递交相关司法文书、对方提交的证据副本等（如有）</p>
        <p class="text ti">其他本公司或保险公司认为对向用户提供理赔服务所必须的材料。</p>
        <p class="text ti">5.理赔结果：保险公司根据用户提交的材料将认定最终理赔结果，如最终确认属于理赔责任范围内的情形，由保险公司向用户支付赔款，最终理赔额在人民币3000元（含3000元）以下的案件由保险公司在确认最终理赔结果后的5个工作日之内支付赔款；最终理赔额在人民币3000元以上的案件由保险公司在确认最终理赔结果后的10个工作日之内支付赔款。</p>
        <p class="title_bold" style="color:red">四、用户的权利与义务</p>
        <p class="text ti">1.用户使用WiFi万能钥匙过程中用户账户资金遭受直接经济损失的，用户有权向保险公司提起索赔申请，经本公司及保险公司认定情况属实并符合索赔条件及范围的，保险公司将依据理赔规则给予用户理赔。</p>
        <p class="text ti">2.用户向保险公司提起索赔申请，应按照本公司用户安全理赔规则提交所有相关索赔材料。用户保证，其所提交的一切索赔材料、所作出的任何陈述或保证均真实准确且合法有效，并应独立承担因违反上述保证所引发的一切法律责任。用户未充分履行上述义务或违反上述保证的，本公司及保险公司有权不予理赔；保险公司已经向该用户支付理赔金的，有权向该用户追回，并要求用户赔偿本公司及保险公司因此遭受的一切损失。同时，本公司及保险公司将向有关机关报案，追究该用户骗保的刑事责任。</p>
        <p class="text ti">3.用户应保证其连接网络及上网过程中的行为不触犯任何法律、行政法规、相关政策且不侵犯任何第三人的合法权益。</p>
        <p class="text ti">4.用户应向保险公司提供真实有效的收款账户信息，因用户原因导致提供的收款信息错误而无法收到理赔额的情况，本公司及保险公司不承担任何责任。</p>
        <p class="text ti">5.用户向保险公司或本公司发起索赔申请，即表明用户已同意严格遵守本公司发布的针对WiFi万能钥匙安全保险计划的所有规则，并同意以最新的规则作为认定最终理赔结果的依据。</p>
        <p class="text ti">6.用户承诺：未经本公司书面许可，不得将最终理赔结果向任何第三方披露。</p>
        <p class="title_bold" style="color:red">五、本公司的权利与义务</p>
        <p class="text ti">1.用户知悉并完全同意本公司有权随时修改、更新、暂停或永久终止保险计划，无需对用户承担任何法律责任。</p>
        <p class="text ti">2.本公司有权依据理赔规则对用户向保险公司的索赔申请进行审核以确定是否向其提供理赔服务，用户同意本公司有完全的权利同意或拒绝用户的申请。</p>
        <p class="text ti">3.本公司对本协议项下的理赔义务承担有限责任，在任何情形下，用户同意保险公司向其支付的理赔金的最高上限依照本协议第（四）条之规定执行。</p>
        <p class="text ti">4.如WiFi万能钥匙及保险公司在审查用户所提交的索赔申请时发现重大刑事案件线索的，本公司及保险公司有权在通知用户后以用户索赔资料为基础向警方提供案件侦查线索或向相关司法机关检举。</p>
        <p class="text ti">5.用户因使用WiFi万能钥匙所遭受的经济损失，通过第三方获得赔付或司法程序或其他合法程序得以追缴或退赔的，若保险公司已根据本保险计划向用户进行赔付的，则有权在其对用户的赔付范围内要求用户进行返还。</p>
        <p class="text ti">6.本公司承诺：未经用户允许，除为实现本协议项下的理赔目的及法律法规隐私保护政策另有规定的情形外，不对外披露或向第三方提供用户的任何信息。</p>
        <p class="title_bold">六、其他</p>
        <p class="title_bold ti">1.本公司郑重提醒用户注意本协议中免除本公司责任和加重用户义务的条款，请用户仔细阅读，自主考虑风险。未成年人应在法定监护人的陪同下阅读本协议。 以上各项条款内容的最终解释权及修改权归本公司所有。</p>
        <p class="text ti">2.本协议所定的任何条款的部分或全部无效者，不影响其它条款的效力。</p>
        <p class="title_bold ti" style="color:red">3.本协议签订地为上海市浦东新区。本协议的解释、效力及纠纷的解决，适用于中华人民共和国法律。若用户和本公司之间发生任何纠纷或争议，首先应友好协商解决，协商不成的，用户在此完全同意双方将纠纷或争议提交上海市浦东新区的人民法院通过诉讼方式解决。</p>
        <p class="text ti">4.本协议的版权由本公司所有，本公司保留对上述条例的最终解释权。</p>
        <p class="text ti">5.本WiFi万能钥匙用户安全保险计划自2016年1月8日起生效施行。</p>
    </div>
  </div>
</template>
<script>
export default {
    mounted:function(){
        this.$trace.enterTraceDone({ page: 5,  type: 'protocolA0009'})
    }
}
</script>
<style scoped>
td{font-size: 12px;}
p{padding: 15px 0 0 0}
</style>



// WEBPACK FOOTER //
// protocolA0009.vue?a2f9b236